import { ConfigObj, ExcessiveEvents, DomHelpers } from '../utils'

const _defaultOpts = {
  container: 'body',
  bottomOffsetElement: '',
  topOffsetElement: '.ps-header',
  hideForElement: '',
  topOffset: 0,
  bottomOffset: 0,
  stickToBottom: false
}

let yAxisAnchor


export default class StickyElement {
  constructor($el, opts) {
    this.$el = $el
    this.opts = ConfigObj.merge(_defaultOpts, opts)
  }

  init() {
    this.setInternalOpts()

    yAxisAnchor = this.opts.stickToBottom ? 'bottom' : 'top'

    this.$placeHolder = this.$el.parentNode.insertBefore(document.createElement('div'), this.$el)
    // Move original element into placeholder - Allows for simpler and more dynamic calculations
    DomHelpers.destroyElement(this.$el)
    this.$placeHolder.appendChild(this.$el)

    this.prepareElements() //  set up initial element states to support this module
    this.setDimensions()
    this.addEventListeners()
    this.letsGetSticky()
  }

  setInternalOpts() {
    if (DomHelpers.isValidSelector(this.opts.container)) {
      this.$container = document.querySelector(this.opts.container)
      if (this.$container == null) this.$container = document.body
    }

    if (DomHelpers.isValidSelector(this.opts.hideForElement)) {
      this.$hideForElement = document.querySelector(this.opts.hideForElement)
      this.opts.shouldHideForEl = this.$hideForElement != null
    }

    if (DomHelpers.isValidSelector(this.opts.topOffsetElement) && this.opts.stickToBottom == false) {
      const $topOffsetEl = document.querySelector(this.opts.topOffsetElement)
      if ($topOffsetEl != null) this.opts.topOffset = $topOffsetEl.offsetHeight
    }

    if (DomHelpers.isValidSelector(this.opts.bottomOffsetElement) && this.opts.stickToBottom) {
      const $bottomOffsetEl = document.querySelector(this.opts.bottomOffsetElement)
      if ($bottomOffsetEl != null) this.opts.bottomOffset = $bottomOffsetEl.offsetHeight
    }
  }

  prepareElements() {
    this.$container.style.position = 'relative'
    this.$el.style.webkitTransform = 'translateZ(0)' // Force webkit GPU to reduce ios10 flickering
    this.$el.style.zIndex = '100'
    this.$el.style.display = 'inline-block' // Fixes weird height switching bug between pos fixed / static
  }

  setDimensions() {
    this.$el.style.width = `${this.$placeHolder.parentElement.offsetWidth}px`

    this.elHeightWithOffset = this.opts.stickToBottom
      ? this.$el.offsetHeight + this.opts.bottomOffset
      : this.$el.offsetHeight + this.opts.topOffset

    // Set placeholder dimensions to ensure parent heights / sibling positions arent affected
    this.$placeHolder.style.height = `${this.$el.offsetHeight}px`
  }

  isDisabled() {
    return this.$container.offsetHeight <= this.elHeightWithOffset
  }

  canStick() {
    return this.opts.stickToBottom
      ? this.$placeHolder.getBoundingClientRect().bottom >= (window.innerHeight - this.opts.bottomOffset)
      : this.$placeHolder.getBoundingClientRect().top - this.opts.topOffset <= 0
  }

  isOutOfBounds() {
    return this.$container.getBoundingClientRect().bottom - this.elHeightWithOffset <= 0
  }

  setStickyPos(positionType, pos) {
    // Only make style changes when postion type changes
    if (positionType == this.$el.style.position) return

    this.$el.style[yAxisAnchor] = `${pos}px`
    this.$el.style.left = `0`
    this.$el.style.position = positionType

    // Make sure the sticky el sits within it's container
    if (positionType === 'absolute') this.$el.style.left = ''
  }

  setStickyElVisibility(displayType) {
    // Only make style changes when display type changes
    if (displayType == this.$el.style.display) return
    this.$el.style.display = displayType
  }

  letsGetSticky() {
    if (this.opts.shouldHideForEl) {
      const hideForElDimensions = this.$hideForElement.getBoundingClientRect()

      hideForElDimensions.top <= window.innerHeight
        && hideForElDimensions.bottom >= window.innerHeight / 2 + (this.elHeightWithOffset / 2)
        ? this.setStickyElVisibility('none')
        : this.setStickyElVisibility('inline-block')
    }

    if (this.canStick() && this.isDisabled() == false) {
      const position = this.opts.stickToBottom ? this.opts.bottomOffset : this.opts.topOffset

      this.setStickyPos('fixed', position)

      if (this.isOutOfBounds()) {
        this.setStickyPos('absolute', this.$container.offsetHeight - this.$el.offsetHeight - this.opts.bottomOffset)
      }

    } else {
      this.setStickyPos('', 0)
    }
  }

  addEventListeners() {
    window.addEventListener('scroll', this.letsGetSticky.bind(this))
    window.addEventListener('resize', ExcessiveEvents.debounce(this.setDimensions.bind(this), 60))
  }
}



// WEBPACK FOOTER //
// ./js/modules/StickyElement.js